import React, {forwardRef} from 'react';
import classNames from 'classnames';
import './styles.scss';

const Item = forwardRef(({ id, name, sortOrder, salesDistricts, isNewCopy, isCopying, salesDistrictScenarioId, changeView, copy, updateName, children, ...props}, ref) => {  
  return (
    <div ref={ref} className="sortable__item">
        <div {...props} className="sortable__trigger">
            <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" draggable="true"><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg>
        </div>
        <input className={classNames({
          'sortable__item-text': true,
          'sortable__item-text--copied': isNewCopy
        })} type="text" value={name} 
            onChange={(e) => updateName(id, e.currentTarget.value)} 
            disabled={isCopying} 
            ref={(input) => { 
              if (isNewCopy && input) {
                input.focus();
              }
            }} />
        <button disabled={isCopying}  title={`Kopiera ${name}`} type="button" className="sortable__item-copy" onClick={() => copy(salesDistrictScenarioId)}></button>
        {sortOrder !== 1 &&
          <button disabled={isCopying} className="sortable__item-delete" onClick={() => changeView('delete', { id, name, sortOrder, salesDistrictScenarioId })} type="button"></button>
        }
    </div>
  )
});

export default Item;